import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import recipeArtwork from '../../../assets/images/recipes-artwork.png';
import { useGetChildrenLessonPlansQuery } from '../../../services/endpoints/schedule/lesson';
import { Lesson } from '../../../types/lesson.type';
import { getRangeDate } from '../../../utils/utils';
import ClassCalendarCard from './ClassCalendarCard';

function getLessonDate(lesson: Lesson): string {
  const date = new Date(lesson.date);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric'
  });
}

function isLessonPast(lesson: Lesson): boolean {
  const date = new Date(lesson.date);
  const today = new Date();
  return date < today;
}

interface ClassDetailsRecipesProps {}

const ClassDetailsRecipes: React.FC<ClassDetailsRecipesProps> = () => {
  const { date } = useParams();
  const initialRange = date?.trim() ? getRangeDate(new Date(date)) : getRangeDate(new Date());

  const [dateRange, setDateRange] = useState({
    starts_on: initialRange.start,
    ends_on: initialRange.end
  });
  const [selectedLessons, setSelectedLessons] = useState<Lesson[]>([]);

  const { data, isLoading, isFetching } = useGetChildrenLessonPlansQuery({
    data: dateRange
  });

  const dateChange = ({ start, end }: { start: string; end: string }) => {
    if (start && end) {
      setDateRange({
        starts_on: start,
        ends_on: end
      });
    }
  };

  const selectedCourseIds = new Set(selectedLessons.map((l) => l.course.id));
  const scheduleLessons = data?.filter((l) => selectedCourseIds.has(l.course.id)) ?? [];

  return (
      <div className="container-fluid">
        <ClassCalendarCard
            dateChange={dateChange}
            lessons={data}
            isLoading={isFetching}
            onLessonsSelected={setSelectedLessons}
        />
        <Row className="d-none d-lg-block">
          <Col style={{ textAlign: 'center' }}>
            <img
                src={recipeArtwork}
                style={{ width: '382px' }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <span style={{ fontWeight: 600, color: '#5E646980' }}>Session Schedule & Recipes</span>
            {scheduleLessons.length === 0 && (
                <p className="text-secondary fst-italic mt-2">
                  Select a class on the calendar to view its full schedule and recipes.
                </p>
            )}
            {scheduleLessons.map((lesson, index) => (
                <p
                    key={`schedule-lesson-${index}`}
                    className="text-secondary"
                >
              <span
                  className="fw-bold text-uppercase"
                  style={{ color: isLessonPast(lesson) ? '#888888' : '' }}
              >
                {getLessonDate(lesson)}{' '}
              </span>
                  <span style={{ color: isLessonPast(lesson) ? '#888888' : '' }}>
                - {lesson.course.title}
              </span>
                  <span
                      className="text-uppercase"
                      style={{
                        color: isLessonPast(lesson) ? '#888888' : '#5E646980'
                      }}
                  >
                {' '}
                    ({lesson.formatted_time} MT)
              </span>
                  <br />
                  {lesson.lesson_plans.map((plan, idx) => (
                      <Link
                          key={`schedule-lesson-plan-${idx}`}
                          to={`/lesson-plans/${plan.slug}`}
                          className="text-capitalize"
                          style={{ textDecoration: 'none', color: '#6098B8' }}
                      >
                        {plan.name}
                      </Link>
                  ))}
                </p>
            ))}
          </Col>
        </Row>
      </div>
  );
};

export default ClassDetailsRecipes;
